import { render, staticRenderFns } from "./animalTable.vue?vue&type=template&id=421c5a71&scoped=true&"
import script from "./animalTable.vue?vue&type=script&lang=js&"
export * from "./animalTable.vue?vue&type=script&lang=js&"
import style0 from "./animalTable.vue?vue&type=style&index=0&id=421c5a71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c5a71",
  null
  
)

export default component.exports